<template>
  <CHeader fixed with-subheader light>
    <CToggler
      in-header
      class="ml-3 d-lg-none"
      @click="$store.commit('toggleSidebarMobile')"
    />
    <CToggler
      in-header
      class="ml-3 d-md-down-none"
      @click="$store.commit('toggleSidebarDesktop')"
    />
    <CHeaderBrand class="mx-auto d-lg-none" to="/">
      <!-- <CIcon name="logo" height="48" alt="Logo"/> -->
      <img src="../assets/img/Logo.png" height="48" />
    </CHeaderBrand>
    <CHeaderNav class="d-md-down-none mr-auto">
      <CHeaderNavItem class="px-3">
        <CHeaderNavLink to="/dashboard">Pages / Dashboard </CHeaderNavLink>
      </CHeaderNavItem>
      <!-- <CHeaderNav class="mr-4"> </CHeaderNav> -->
    </CHeaderNav>
    <CHeaderNav class="mr-4">
      <CHeaderNavItem class="d-md-down-none mx-2">
       
        <CHeaderNavLink>

           <img
                    v-if="user.FilePath == null"
                    style="border: 1px solid #eee; width: 20px; height: 20px;border-radius:50%; object-fit: cover;"
                    src="../assets/img/default.png"
                    class="grey lighten-2"
                  />

                  <img
                    v-else
                    style="
                      border: 3px solid #ddd;
                      background: #fff;
                      width: 30px;
                      height: 30px;
                      border-radius:50%;
                       object-fit: cover;
                    "
                    :src="getPic(user)"
                    class="grey lighten-2"
                  />


        <label v-on:click="SignOut()" class="ml-2"> Sign Out</label> 
        </CHeaderNavLink>
      </CHeaderNavItem>
    </CHeaderNav>
    <CSubheader class="px-3">
      <CBreadcrumbRouter style="pointer-events: none;" class="border-0 mb-0" />
    </CSubheader>
  </CHeader>
</template>

<script>
import TheHeaderDropdownAccnt from "./TheHeaderDropdownAccnt";

export default {
  name: "TheHeader",
  components: {
    TheHeaderDropdownAccnt,
  },
   data() {
    return {
      user: {},
    };
  },
  async mounted() {
    this.GetProfilePicture()
  },
  methods: {
    GetProfilePicture() {
      this.$API
        .get(this.$ViewProfilePictureAdmin, {
          withCredentials: true,
        })
        .then((response) => {
          if (response.status == 200 && response.data != null) {
            this.user = response.data;
            this.getPic(user);
          }
        });
    },
     SignOut: function () {
      return this.$API
        .get(this.$SignOut, {
          withCredentials: true,
        })
        .then((response) => {
          if (response.status == 200) {
            this.$router.push("/Login");
          }
        });
    },
     getPic(user) {
      return "https://54.254.198.108/File/" + user.FilePath;
    },
  }
};
</script>
